import { getCourseGroupsUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class CourseGroupService {
  static getCourseGroups = () => {
    return getRequest(getCourseGroupsUrl());
  };

  static getCourseGroupById = (courseGroupId) => {
    return getRequest(getCourseGroupsUrl() + "/" + courseGroupId);
  };

  static getCoursesByGroupById = (courseGroupId) => {
    return getRequest(getCourseGroupsUrl() + "/courses/" + courseGroupId);
  };

  static createCourseGroup = (courses, groupType, name) => {
    let params = { courses: courses, groupType: groupType, name: name };
    return postRequest(getCourseGroupsUrl(), params);
  };

  static updateCourseGroup = (courseGroupId, courses, groupType, name) => {
    let params = { courses: courses, groupType: groupType, name: name };
    return putRequest(getCourseGroupsUrl() + "/" + courseGroupId, params);
  };

  static deleteCourseGroup = (courseGroupId) => {
    return deleteRequest(getCourseGroupsUrl() + "/" + courseGroupId);
  };
}
